var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36931",
    "data-name": "Group 36931",
    transform: "translate(13143 -9871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer_19",
    "data-name": "Layer 19",
    d: "M22.671,8.051a1.585,1.585,0,1,1,0,3.171,1.4,1.4,0,0,1-.317-.063l-.42-.143a1.427,1.427,0,0,1-.476-.388l-.27-.436a1.5,1.5,0,0,1-.119-.571A1.585,1.585,0,0,1,22.671,8.051ZM13.159,6.466A1.482,1.482,0,0,1,14.641,7.94a1.451,1.451,0,0,1-.658,1.2l-.27.127a1.585,1.585,0,0,1-.547.111,1.451,1.451,0,0,1-.555-.119l-.159-.1a1.451,1.451,0,0,1-.793-1.268,1.474,1.474,0,0,1,1.5-1.443Zm-3.171,7.84,2.418-3.9a2.3,2.3,0,0,0,1.506,0l2.418,3.884,4.5-2.8a2.544,2.544,0,0,0,.46.357l-2.14,6.429H7.174l-2.14-6.429a2.545,2.545,0,0,0,.46-.357ZM3.647,8.3A1.348,1.348,0,0,1,5,9.652a1.379,1.379,0,0,1-.1.484l-.23.373A1.348,1.348,0,1,1,3.647,8.3Zm15.56,13.428H7.134V20H19.207Z",
    transform: "translate(-13144.275 9868.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1178",
    "data-name": "Rectangle 1178",
    width: 24,
    height: 24,
    transform: "translate(-13143 9871)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrime);
export default __webpack_public_path__ + "static/media/prime.e0ac363c2ac44e394374339367c23e22.svg";
export { ForwardRef as ReactComponent };